import { cn } from '../lib/utils';

export function ProgressBar({ value, className, showLabel = true }) {
  const percentage = Math.min(Math.max(value, 0), 100);
  
  return (
    <div className={cn("w-full", className)}>
      {showLabel && (
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-slate-600">Progreso</span>
          <span className="text-sm font-bold text-primary">{percentage.toFixed(1)}%</span>
        </div>
      )}
      <div className="progress-bar">
        <div 
          className="progress-fill"
          style={{ width: `${percentage}%` }}
          data-testid="progress-fill"
        />
      </div>
    </div>
  );
}
